module.exports = __webpack_public_path__ + "img/flowers_desktop.11d31e9c.png";